'use strict';

var base = require('../product/base');
var debounce = require('lodash/debounce');

var myDefaultWhiteList = $.fn.selectpicker.Constructor.DEFAULTS.whiteList;
myDefaultWhiteList.div = ['data-option'];

myDefaultWhiteList['*'].push();

var debouncedHandleLineTextSelection = debounce(handleLineTextSelection, 500);

var newPersonalization = $('.new-pdp-layout').length > 0;

/**
 *
 * @param position - Name of the position [Left Chest, Right Chest, ...]
 * @param type - [Embroidery, Emblem]
 * @param line - [Line 1, Line 2, Line 3]
 * @returns locCode - location code
 */
function getLocationCode(position, type, line) {
    if (line) {
        var fullLocation = position + " " + type + " Line " + line;
    } else {
        var fullLocation = position + " " + type;
    }
    var locCode = $(".locationcode[data-location='" + fullLocation + "']").data('code');

    return locCode;
}

/**
 * To handle line text field input
 * @param $this - Current event selector
 * @param set - selected Set
 * @returns void
 */
function handleLineTextSelection($this, set) {
	var set = $this.data('set');
	//$('.embroideryset-' + set).removeClass('customized');
	$(".js-addEmbroidery[data-set='" + set + "']").each(function () {
		var embLine = $(this).data('line');
		if (set == '2') {
		    embLine = parseInt(embLine) + 3;
		}
    	var price = $('.js-embroideryLine' + embLine + ' option[data-value-id=line' + embLine + ']').data('price');
    	if ($(this).val().trim() != "") {
    	    $(this).prev().find('span').text(':  ' + price);
    	    $('.embroideryset-' + set).addClass('customized');
    	} else {
    		$(this).prev().find('span').text('');
    	}
    });

	styleLineTextBox(set);

	if (!newPersonalization) {
		generateJSONData(set);

		updateProductPrice();
		var linetextFlag = $(".js-addEmbroidery[data-set='" + set + "']").filter(function() {
			return $(this).val().trim().length > 0
	   });
   
	   if (linetextFlag.length > 0) {
		   $('.embroidery_disclaimer').show();
	   } else {
		   $('.embroidery_disclaimer').hide();
	   }
	}
	validatePersonalization(set);
}

/**
 * function for getting selected embroidery background color
 * @returns bgColor - Background color for input fields
 */
function getBGColor() {
    var bgColor = "rgba(255,255,255,255)";
    var productSwatch = $(".main-product .swatch-value.selected .selection_swatch_color__bg");

    if (productSwatch.length) {
        bgColor = productSwatch.css('background-image');
    }

    return bgColor;
}

/**
 * To style the line text input box based on selection of font and color
 * @param $this - Current event selector
 * @param set - selected Set
 * @returns void
 */
function styleLineTextBox(set) {
	var rgba = getBGColor();
    var font = $(".js-embFont[data-set='" + set + "']").val();
    var color = $(".js-embColor[data-set='" + set + "']").val();

    var attrUpdate = "background-image: " + rgba + ";";
    var classUpdate = "embColor-" + color;
    var $staticEmbroideryPositionColor = $(".js-static-embroidery-position-color[data-set='" + set + "']");

    if ($staticEmbroideryPositionColor.length) {
        var value = $staticEmbroideryPositionColor.val();

        if (value && value.split('-').length == 2) {
            var positionVal = value.split('-')[0];
            var bgColorVal = value.split('-')[1];
            var getPositionChange = $(".js-position-change[data-set='" + set + "']").val();

            if (getPositionChange && positionVal
                && (getPositionChange.toUpperCase() == positionVal.toUpperCase() || getPositionChange == 'none')) {
                attrUpdate = "background-color: " + bgColorVal + ";";
            }
        }
    }

    $(".js-addEmbroidery[data-set='" + set + "']").each(function () {
        $(this).removeClass (function (index, css) {
            return (css.match (/(^|\s)embColor\S+/g) || []).join(' ');
         });
        $(this).attr("style", attrUpdate).attr('data-font', font).addClass(classUpdate);
    });

    $(".embroidery .emblemBox").each(function () {
        $(this).attr("style", attrUpdate);
    });
}

/**
 * To generate JSON data contains logo and/or line text for selected set
 * @param set - selected Set
 * @returns void
 */
function generateJSONData (set) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");

	var position = $embroideryset.find('.js-select-position.selected').attr('data-position');
	var embroideryData = [];
	/* Generate JSON data for Line text field */
	$(".js-addEmbroidery[data-set='" + set + "']").each(function () {
		var lineText = $(this).val();
		var lineNo = $(this).data('line');
		var embLine = lineNo;
		if (set == '2') {
		    embLine = parseInt(lineNo) + 3;
		}
		if (lineText.trim() !== '') {
			var locCode = getLocationCode(position, 'Embroidery', lineNo);
	        var price = $('.js-embroideryLine' + embLine + ' option[data-value-id=line' + embLine + ']').data('price');
	        var font = $(".js-embFont[data-set='" + set + "']").val();
	        var color = $(".js-embColor[data-set='" + set + "']").val();
	        embroideryData.push({"isLogo":false,"locCode":locCode,"price":price.replace('$', ''),"font":font,"color":color,"text":lineText,"set":set});
		}
	});

	/* Generate JSON data for logo/emblem */
    if ($embroideryset.find('.emblemBox img').length > 0) {
    	var locCode = getLocationCode(position, 'Emblem', null);
    	var image = $embroideryset.find('.emblemBox img');
    	var price = image.attr('data-price');
    	var selectedName = image.attr('alt');
    	embroideryData.push({"isLogo":true,"locCode":locCode,"price":price,"selectedName":selectedName});
    }

    /* set new logo in localstorage based on logo art checkbox */
    var isLogoArtChecked = $embroideryset.find('input.js-logoArtCheckbox').hasClass('checked') ? true : false;
    localStorage.setItem('isLogoArtChecked' + set, isLogoArtChecked);

    var embroideryDataString = JSON.stringify(embroideryData);
    $('.js-finalBuild-'+ set +'-input').val(embroideryDataString).attr('value', embroideryDataString);
    return;
}

/**
 * To update product price based on selection of product options
 * @returns void
 */
function updateProductPrice () {
	$('.data-embroidery').each(function() {
		var set = $(this).parents('.embroideryset').attr('data-set');
		var $embroideryset = $(".embroideryset[data-set='" + set + "']");
		var embroideryDataString = $(this).val();

		/* Reset product options only */
		resetEmbroideryData(set, false, true);

		if (embroideryDataString.length > 2) {
			var embroideryJSON = JSON.parse(embroideryDataString);
			$.each(embroideryJSON, function(i, data){
				var j = (set == 2) ? ++i + 3 : ++i;
				if(!data.isLogo) {
					$('.js-embroideryLine' + j + ' option[data-value-id="line' + j + '"]').prop('selected', true);
				} else {
					$('.js-graphic' + set + ' option[data-value-id="' + data.price + '"]').prop('selected', true);
				}
			});
		}
	});

    base.attributeSelect(null, $('.product-detail').find('.js-main-product'));
}

/**
 * To validate personalization upon applying
 * @param set - selected Set
 * @returns void
 */
function validatePersonalization (set, isSubmitted = false) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	var isLineTextValid = false;
	var isLogoValid = false;
	var isNewLogoValid = false;

	/* Line text validation */
	var isTextAdded = false;
	var isStyleAdded = true;
	var font = $(".js-embFont[data-set='" + set + "']").val();
    var color = $(".js-embColor[data-set='" + set + "']").val();

    $embroideryset.find('.embroidery__input').each(function () {
        if ($(this).val().trim() !== '') {
        	isTextAdded = true;
        }
    });
    if (isTextAdded && isSubmitted) {
        if (color === null || color.indexOf("Select") > -1) {
            $embroideryset.find('.options-thread-color').addClass('invalid');
            isStyleAdded = false;
        } else {
        	$embroideryset.find('.options-thread-color').removeClass('invalid');
        }
        if (font === null || font.indexOf("block") > -1 && font.length >= 5) {
            $embroideryset.find('.options-font').addClass('invalid');
            isStyleAdded = false;
        } else {
        	$embroideryset.find('.options-font').removeClass('invalid');
        }
    }
    isLineTextValid = (isTextAdded && isStyleAdded);

    /* Stock logo and custom logo validation */
    if ($embroideryset.find('.emblemBox img').length > 0) {
    	isLogoValid = true;
    }

    /* New logo checkbox validation */
    if ($embroideryset.find('input.js-logoArtCheckbox').hasClass('checked')) {
    	isLogoValid = true;
    }

    var isValid = isTextAdded ? isLineTextValid : (isLogoValid || isNewLogoValid);
    if (isValid) {
    	$($embroideryset).find('.js-done-btn').removeClass('disabled');
    } else if (!isSubmitted){
    	$($embroideryset).find('.js-done-btn').addClass('disabled');
    }
    return isValid;
}

/**
 * @param set - current embroidery set
 * @returns void
 */
function hideEmbroiderySet (set) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	$embroideryset.removeClass('editembroset');
	/* Logo header section */
	$embroideryset.find('.logo-tab-container').hide();
	/* Logo content section */
	$embroideryset.find('.embroideryGraphic').removeClass('active');
	$embroideryset.find('.js-customLogoContainer').removeClass('active');
	$embroideryset.find('.embroidery__logo-search').removeClass('active');
	/* Line text option section */
	$embroideryset.find('.embroidery-line-options').removeClass('active');
	/* Line text input field section */
	$embroideryset.find('.embroidery__inputs').removeClass('active');
	$embroideryset.find(".js-addEmbroidery").prev().find('span').text('');
	$embroideryset.find('.line-section span').text('').attr('data-price', 0);

	if ($embroideryset.find('.data-embroidery').val().length > 2 || localStorage.getItem('isLogoArtChecked' + set) == 'true') {
		$('.embroidery-sets').show();
		$(".embroidery-set[data-set='" + set + "']").addClass('completed');
	}
	if ($('.data-embroidery').val().length > 2) {
        $(".embroidery_disclaimer").show();
    } else {
    	$(".embroidery_disclaimer").hide();
    }
	$embroideryset.hide();
	if ($(".embroidery-set.completed").length != $(".embroidery-set").length && !$(".embroideryset").is(':visible')) {
		$('.embroidery__addset__option').show();
    } else {
        $('.embroidery__addset__option').hide();
    }
}

/**
 * @param set - current embroidery set
 * @returns void
 */
function showEmbroiderySet (set) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	$embroideryset.show();

	if (newPersonalization || $embroideryset.find(".emblemBox").find('img').length) {
		$embroideryset.addClass('editembroset');

		if ($($embroideryset).find('button.js-select-position.selected').text().includes('Add') || $($embroideryset).find('button.js-select-position.selected').text().includes('Edit')) {
			$($embroideryset).find('button.js-select-position.selected').text($($embroideryset).find('button.js-select-position.selected').text().replace('Add', ''))
			$($embroideryset).find('button.js-select-position.selected').text($($embroideryset).find('button.js-select-position.selected').text().replace('Edit', ''))
		}
	}

	$embroideryset.find('.select-location-label').addClass('d-none');
	/* Logo header section */
	$embroideryset.find('.logo-tab-container').show();
	/* Logo content section */
	$('.new-pdp-layout .embroideryGraphic.set-' + set).addClass('active');
	/* Line text option section */
	$embroideryset.find('.embroidery-line-options').addClass('active');
	/* Line text input field section */
	$embroideryset.find('.embroidery__inputs').addClass('active');

	$(".embroidery-set[data-set='" + set + "']").removeClass('completed');

	if ($('.embroidery-set.completed').length < 1) {
		$('.embroidery-sets').hide();
	}

	$(".embroidery_disclaimer").show();

	$('.embroidery__addset__option').hide();
}

/**
 * To set embroidery data input fields/logo based on finalBuild data available
 * @param set - current embroidery set
 * @returns void
 */
function setEmbroideryData (set) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	var embroideryDataString = $('.js-finalBuild-'+ set +'-input').val();
	$embroideryset.find('.logo-tab-container button').removeClass('active-btn');
	if (embroideryDataString.length > 2) {
		var embroideryJSON = JSON.parse(embroideryDataString);
		$.each(embroideryJSON, function(i, data){
			var j = (set == 2) ? ++i + 3 : ++i;
			var location = getLocationName(data.locCode);
			setLocationActive(set, location);
			if(!data.isLogo) {
				/* Line text field data entry */
				$('input.js-embroideryLine' + j).val(data.text).attr('value', data.text);
				$('input.js-embroideryLine' + j).closest('.form-group').addClass('textadded').show();
				$('input.js-embroideryLine' + j).parents('.line-item').addClass('active');
				$('input.js-embroideryLine' + j).parents('.form-group').prev().find('input').addClass('w-100');
				$('input.js-embroideryLine' + j).parents('.form-group').prev().find('.line-link').addClass('d-none');
				$embroideryset.find('input.js-embroideryLine' + j).prev().find('span').text(': $' + data.price);
				$embroideryset.find(".js-embColor").val(data.color).closest('.selectpicker').selectpicker('refresh');
				$embroideryset.find(".js-embFont").val(data.font).closest('.selectpicker').selectpicker('refresh');
				if ($embroideryset.find('.embroidery__inputs input').length == $embroideryset.find('.form-group.textadded').length) {
					$embroideryset.find(".js-add-line, .js-add-line__divider").hide();
				}
				$embroideryset.find('.textadded').last().addClass('show-line-link');
			} else {
				var logoSelector = $embroideryset.find('button[data-name="' + data.selectedName + '"]');
				if (logoSelector.length > 0) {
					/* Stock logo/Customer logo section selection*/
					logoSelector.addClass('active').click();
					if (logoSelector.parents('.logo-tab-content').hasClass('stock-logo-content')) {
						$embroideryset.find('button.stock-logo').addClass('active-btn');
						$embroideryset.find('.stock-logo-content').addClass('active');
					} else {
						$embroideryset.find('button.js-your-logo').addClass('active-btn');
						$embroideryset.find('.your-logo-content').addClass('active');
					}
				} else {
					/* Guest custom logo selection*/
					$embroideryset.find('button.js-your-logo').addClass('active-btn');
					$embroideryset.find('.your-logo-content').addClass('active');
					$embroideryset.find('input.js-custom-logo').val(data.selectedName).attr('value', data.selectedName);
					$embroideryset.find('.custom-logo-button').click();
				}
			}
		});
	}

	if (localStorage.getItem('isLogoArtChecked' + set) == 'true') {
		/* New logo section selection */
		$embroideryset.find('input.js-logoArtCheckbox').addClass('checked').prop('value', true).prop('checked', true);
		$embroideryset.find('.get-new-logo').addClass('active-btn');
		$embroideryset.find('.new-logo-content').addClass('active');
	}

	styleLineTextBox(set);
}

/**
 * To reset embroidery set options and fields based on flags passed
 * @param set - current embroidery set
 * @returns
 */
function resetEmbroideryData (set, resetFields, resetOptions) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	var options = (set == 1) ? ['embroideryLine1', 'embroideryLine2', 'embroideryLine3', 'graphic1'] : ['embroideryLine4', 'embroideryLine5', 'embroideryLine6', 'graphic2'];

	$.each(options, function(i, optionName){
		if (resetOptions) {
			$('.js-' + optionName + ' option[data-value-id="none"]').prop('selected', true);
			//localStorage.setItem('isLogoArtChecked' + set, false);
		}
		if (resetFields) {
			if (optionName.indexOf('graphic') > -1) {
				resetLogoSelection(set);
				$embroideryset.find('.js-custom-logo').removeClass('is-invalid');
				$embroideryset.find(".js-customLogoContainer").find(".invalid-feedback").hide();
			} else {
				$('input.js-' + optionName).val('').attr('value', '');
				$embroideryset.find(".js-embColor").prop("selectedIndex", 0).closest('.selectpicker').selectpicker('refresh');
				$embroideryset.find(".js-embFont").prop("selectedIndex", 0).closest('.selectpicker').selectpicker('refresh');
			}
		}
	});
	return;
}

/**
 * To get location name by location code
 * @param code
 * @returns locationName - Location name of passed location code
 */
function getLocationName (code) {
	if (code != '') {
		var locationData = $('.locationcode[data-code="' + code + '"]').data('location');
		var locSplitData = locationData.split(" ");
		var locationName = locSplitData[0] + ' ' + locSplitData[1];
		/* Multiple location names are there with same code. So iterate and find it */
		$('.locationcode').each(function() {
			var locationCode = $(this).data('code');
			locationData = $(this).data('location');
			locSplitData = locationData.split(" ");
			locationName = locSplitData[0] + ' ' + locSplitData[1];
			if (locationCode == code && $('.js-select-position[data-position="' + locationName + '"]').length > 0){
				return false;
			}
		});
	}

    return locationName;
}

/**
 * To set location as selected based on passed set and location name
 * @param set - current embroidery set
 * @param location - Location name
 * @returns void
 */
function setLocationActive (set, location) {
	//same set
    $(".js-select-position[data-set='" + set + "']").removeClass('selected');
    $(".js-select-position[data-set='" + set + "'][data-position='" + location + "']").addClass('selected')
    																				  .removeClass('disabled');
	
    $(".js-position-change[data-set='" + set + "'] option[data-position='" + location + "']").prop('selected', true)
    																				  .closest('.selectpicker').selectpicker('refresh');
    //other sets
    $(".js-select-position[data-set!='" + set + "'][data-position='" + location + "']").addClass('disabled');		
    $(".js-select-position[data-set!='" + set + "'][data-position!='" + location + "']").removeClass('disabled');

	if (newPersonalization) {
		$("button.js-select-position[data-set='" + set + "'][data-position='" + location + "']").text($("button.js-select-position[data-set='" + set + "'][data-position='" + location + "']").text().replace('Add', ''))
		if (location !== 'none' &&  !$("button.js-select-position[data-set!='" + set + "'][data-position='" + location + "']").text().toLowerCase().includes('edit')) {
			$("button.js-select-position[data-set!='" + set + "'][data-position='" + location + "']").text($("button.js-select-position[data-set!='" + set + "'][data-position='" + location + "']").text().replace('Add', ''))
			$("button.js-select-position[data-set!='" + set + "'][data-position='" + location + "']").text('Edit ' + $("button.js-select-position[data-set!='" + set + "'][data-position='" + location + "']").text())
		}
		if ( location !== 'none' && !$("button.js-select-position[data-set!='" + set + "'][data-position!='" + location + "']").text().toLowerCase().includes('add')) {
			$("button.js-select-position[data-set!='" + set + "'][data-position!='" + location + "']").text($("button.js-select-position[data-set!='" + set + "'][data-position!='" + location + "']").text().replace('Edit', ''))
			$("button.js-select-position[data-set!='" + set + "'][data-position!='" + location + "']").text('Add ' + $("button.js-select-position[data-set!='" + set + "'][data-position!='" + location + "']").text());
		}
	}
	
	
    $("select.js-position-change[data-set!='" + set + "'] option[data-position='" + location + "']").attr('disabled', 'disabled');
    $("select.js-position-change[data-set!='" + set + "'] option[data-position!='" + location + "']").removeAttr('disabled', 'disabled');
    $("select.js-position-change[data-set!='" + set + "']").closest('.selectpicker').selectpicker('refresh');

    return;
}

/**
 * To display embroidery selection for customer after clicking apply personalization
 * @param set
 * @returns void
 */
function displayEmbroiderySelection (set) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	var $logoDiv = '';
	var $lineDiv = '';
    var $container = "div.position-" + set;

    var logoText = "";
    var logoName = "";

    var embroideryDataString = $embroideryset.find('input.data-embroidery').val();
    if (embroideryDataString.length > 2) {
    	var textCount = 1;
    	var embroideryJSON = JSON.parse(embroideryDataString);
		$.each(embroideryJSON, function(i, data){
			if(data.isLogo) {
				if ($embroideryset.find('.basicGraphic[data-name="' + data.selectedName + '"]').length > 0) {
					logoText = 'Emblem: ';
					logoName = $embroideryset.find('.basicGraphic[data-name="' + data.selectedName + '"] img').attr('alt');
				} else {
					logoText = 'Logo: ';
					logoName = data.selectedName;
				}
				$logoDiv = '<div>' + logoText + logoName + '</div>';
			} else {
				$lineDiv = $lineDiv + '<div>' + 'Line ' + textCount + ': ' + data.text + '</div>';
				textCount++;
			}
		});
    }

    if (localStorage.getItem('isLogoArtChecked' + set) == 'true') {
     	$logoDiv = '<div>New Logo Embroidery Requested</div>';
    }

    if ($logoDiv != '' || $lineDiv != '') {
    	var $divContent = $logoDiv + $lineDiv;
    	$($container).html('').append($divContent);
    	$(".embroidery-sets").show();
    	$embroideryset.hide();
    	$(".embroidery_disclaimer").show();
    }
}

/**
 * To remove the completed embroidery set
 * @param set - selected embroidery set
 * @returns void
 */
function removeEmbroiderySet (set) {
	var position = $("select.js-position-change[data-set='" + set + "']").val();
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	if ($embroideryset.length > 0){
		$embroideryset.find('.emb-texts').text('');

		$embroideryset.find("select.selectpicker").prop("selectedIndex", 0).selectpicker('refresh');
		$embroideryset.find('.select-location-label').removeClass('d-none');

		/* Remove logo selection */
		$embroideryset.find('.logo-tab-container', '.positionHeaderContainer .js-remove-position').hide();
		$embroideryset.find('.logo-tab-container button').removeClass('active-btn');
		$embroideryset.find('.logo-tab-content').removeClass('active');
		$embroideryset.find('.logo-preview-sec').removeClass('active');
		$embroideryset.find('.basicGraphic').show();

		if (newPersonalization) {
			$embroideryset.find('.embroidery-line-options, .js-embroidery-inputs, .custom-logo-container').removeClass('active');
			$embroideryset.find('.embroideryGraphic').removeClass('logos-preview-active');
			$embroideryset.find('.select-location-label').removeClass('d-none');
	    }
		$embroideryset.find('.embroideryGraphic').removeClass('active');
	    /* Remove Line texts selection */
		$(".js-addEmbroidery[data-set='" + set + "']").val("");
		$(".js-addEmbroidery[data-set='" + set + "']").prev().find('span').text('');
		$embroideryset.find('.line-section span').text('').attr('data-price', 0);

	    $(".embroidery-set[data-set='" + set + "']").removeClass('completed');

	    /* Remove position selection */
	    $(".js-select-position[data-set='" + set + "']").removeClass('selected');
	    $(".js-select-position[data-set!='" + set + "'][data-position='" + position + "']").removeClass('disabled');
		if (newPersonalization) {
			$("button.js-select-position[data-set!='" + set + "'][data-position='" + position + "']").text($("button.js-select-position[data-set!='" + set + "'][data-position='" + position + "']").text().replace('Add ' , ''))
		}
	    $("select.js-position-change[data-set!='" + set + "'] option[data-position='" + position + "']").removeAttr("disabled");
	    $("select.js-position-change[data-set!='" + set + "']").closest('.selectpicker').selectpicker('refresh');
	    $(".embroidery-set[data-set='" + set + "']").removeClass('completed');
	    $embroideryset.removeClass('editembroset customized').hide();

	    $('.js-finalBuild-' + set + '-input').val('').attr('value', '');

	    var otherSet = set == 2 ? 1 : 2;
	    if (!$(".embroideryset[data-set!='" + set + "'] .data-embroidery").length ||
	    		(!($(".embroideryset[data-set!='" + set + "'] .data-embroidery").val().length > 2) && localStorage.getItem('isLogoArtChecked' + otherSet) != 'true')) {
		    $(".embroidery-sets").hide();
	        $(".js-select-position[data-set='" + set + "'][data-position!='" + position + "']").removeClass("disabled");
	        $("select.js-position-change[data-set='" + set + "']").closest('.selectpicker').selectpicker('refresh');
	        if (!$(".embroideryset").is(':visible') && !$('.edit-pesonalization-page').length > 0) {
	            $(".embroideryset[data-set='1']").show();
	            $(".embroidery_disclaimer").hide();
	        }
	    } else {
	        if ($(".embroidery-set.completed").length != $(".embroidery-set").length && !$(".embroideryset").is(':visible')) {
	            $('.embroidery__addset__option').show();
	        }
	    }
	    /* Reset both field values and options */
	    resetEmbroideryData(set, true, true);
	}
}

/**
 * To shift the embroidery set data from set 2 to set 1
 * @returns void
 */
function shiftEmbroiderySet () {
	var $embroideryset1 = $(".embroideryset[data-set='1']");
	var $embroideryset2 = $(".embroideryset[data-set='2']");
	var isEdited = false;

	/* Copy set 2 final data to set 1 and remove it from set 2 */
	var secondSetFinalData = $('.js-finalBuild-2-input').val();
	var replacedSetData = secondSetFinalData.replace(/"set":2/g, '"set":"1"');
	$('.js-finalBuild-1-input').val(replacedSetData).attr('value', replacedSetData);
	$('.js-finalBuild-2-input').val('').attr('value', '');

	/* Copy set 2 position to set 1 and make set 2 available */
	var secondPosition = $('.embroidery-set[data-set=2] .js-select-position.selected').data('position');
	$('.js-position-change[data-set="2"]').val('none').change();
	setLocationActive('1', secondPosition);

	/* Reset both field values and options */
	resetEmbroideryData('1', true, true);

	/* Copy new logo selection from set 2 to set 1 */
	if (newPersonalization) {
		localStorage.setItem('isLogoArtChecked1', localStorage.getItem('isLogoArtChecked2'));
		localStorage.setItem('isLogoArtChecked2', false);
	}
	/* Copy line text section from set 2 to set 1 */
	$embroideryset1.find('.js-addEmbroidery').each (function() {
		var targetLine = $(this).attr('data-line');
		var sourceLine = parseInt (targetLine) + 3;
		var lineText = $('.embroideryset-2').find('.js-embroideryLine' + sourceLine).val();
		if (lineText.trim() != '') {
			var price = $('.js-embroideryLine' + targetLine + ' option[data-value-id=line' + targetLine + ']').data('price');
			$embroideryset1.find('input.js-embroideryLine' + targetLine).val(lineText).attr('value', lineText);;
			$embroideryset1.find('input.js-embroideryLine' + targetLine).prev().find('span').text(':  ' + price);
			$embroideryset1.find(".js-embColor").val($('.embroideryset-2').find('.js-embColor option:selected').val()).closest('.selectpicker').selectpicker('refresh');
			$embroideryset1.find(".js-embFont").val($('.embroideryset-2').find('.js-embFont option:selected').val()).closest('.selectpicker').selectpicker('refresh');
			isEdited = true;
		}
	});
	/* Copy logo section from set 2 to set 1 */
	var logoName = $embroideryset2.find('.emblemBox img').length ? $embroideryset2.find('.emblemBox img').attr('alt') : '';
	var logoSelector = $embroideryset2.find('.logo-tab-content button[data-name="' + logoName + '"]');
	if (logoSelector.length > 0) {
		/* Stock logo/Customer logo section selection*/
		$embroideryset1.find('.logo-tab-content button[data-name="' + logoName + '"]').click();
		if (logoSelector.parents('.logo-tab-content').hasClass('stock-logo-content')) {
			$embroideryset1.find('button.stock-logo').addClass('active-btn');
			$embroideryset1.find('.stock-logo-content').addClass('active');
		} else {
			$embroideryset1.find('button.js-your-logo').addClass('active-btn');
			$embroideryset1.find('.your-logo-content').addClass('active');
		}
		isEdited = true;
	} else if (logoName !=''){
		/* Guest custom logo selection*/
		$embroideryset1.find('button.js-your-logo').addClass('active-btn');
		$embroideryset1.find('.your-logo-content').addClass('active');
		$embroideryset1.find('input.js-custom-logo').val(logoName).attr('value', logoName);
		$embroideryset1.find('.custom-logo-button').click();
		isEdited = true;
	} else if ($embroideryset2.find('.js-logoArtCheckbox').hasClass('checked')) {
		/* New logo section selection */
		$embroideryset1.find('input.js-logoArtCheckbox').addClass('checked').prop('value', true).prop('checked', true);
		$embroideryset1.find('.get-new-logo').addClass('active-btn');
		$embroideryset1.find('.new-logo-content').addClass('active');
		isEdited = true;
	}

	

	if ((isEdited && $embroideryset2.hasClass('editembroset'))) {
		$('.embroideryset-2').find('.js-remove-position').trigger('click');
		displayEmbroiderySelection('1');
		$('.embroidery-sets').hide();
		$embroideryset1.show();
		$(".js-select-position.selected[data-set='1']").trigger('click');
	} else {
		displayEmbroiderySelection('1');
		$('.embroideryset-2').find('.js-remove-position').trigger('click');
		$(".js-select-position[data-set='2'][data-position='" + secondPosition + "']").addClass('disabled');
		$("select.js-position-change[data-set='2'] option[data-position='" + secondPosition + "']").attr('disabled', 'disabled');
		if (newPersonalization) {
			if (!$("button.js-select-position[data-set='2'][data-position='" + secondPosition + "']").text().toLowerCase().includes('edit')) {
				$("button.js-select-position[data-set='2'][data-position='" + secondPosition + "']").text('Edit ' + $("button.js-select-position[data-set='2'][data-position='" + secondPosition + "']").text())
			}
			if ($("button.js-select-position[data-set='2'][data-position!='" + secondPosition + "']").text().includes('Edit')) {
				$("button.js-select-position[data-set='2'][data-position!='" + secondPosition + "']").text($("button.js-select-position[data-set='2'][data-position!='" + secondPosition + "']").text().replace('Edit', 'Add'))
			}
		}	
		
	}
}

/**
 * To reset logo selection of selected embroidery set
 * @param set - current embroidery set
 * @returns void
 */
function resetLogoSelection (set) {
	var $embroideryset = $(".embroideryset[data-set='" + set + "']");

    /* To deactivate tab header and content */
	$embroideryset.find('.logo-tab-container').find('button').removeClass('active-btn');
    $embroideryset.find('.logo-tab-content').removeClass('active');

	/* Reset logo selections of all tabs */
	$embroideryset.find(".js-select-graphic").removeClass('selected');
	$embroideryset.find(".js-select-ALgraphic").removeClass('selected');
	$embroideryset.find('.js-custom-logo').removeClass('custom-logo-code').val('');
	$embroideryset.removeClass('showcustomlogo');
	$embroideryset.find('.js-customLogoContainer').removeClass('active');
	$embroideryset.find('.js-customLogoContainer div.js-customLogoResponse').removeClass('active').text('');
	$embroideryset.find("input.js-logoArtCheckbox").prop('checked', false).removeClass('checked').prop('value', false);
	if ($embroideryset.find(".stock-logo").hasClass('active-btn')) {
		$embroideryset.find('.js-select-graphic').first().focus();
	}

	/* Reset preview section */
	$embroideryset.find(".logo-preview-sec").removeClass('active');
	if (newPersonalization) {
		$embroideryset.find(".emblemBox").html("<div class='emblemBox__text'>Your Logo Here</div>");
        $embroideryset.find('.logo-preview-sec').removeClass('active');
    } else {
    	$embroideryset.find(".emblemBox").html('<button type="button" class="emblemBox__text js-add-emblem js-embroidery-tab"><i class="fas fa-plus" aria-hidden="true"></i> Add Emblem</button>');
        $embroideryset.find('.embroidery__logo-search').removeClass('active');
    }
	$embroideryset.find('.emblemBox').next().remove();
}

/**
 * To set position/tab selection after login
 * @returns
 */
function setActiveSelection () {
	var activeData = localStorage.getItem('activeEmbroideryData');
	if (activeData != null) {
		var activeDataArray = activeData.split('|');
		var set = activeDataArray[0];
		if (set == 2) {
			if ($('.js-finalBuild-1-input').val().length > 2) {
				$('.js-add-location').trigger('click');
			} else {
				set = 1;
			}
		}

		var $embroideryset = $(".embroideryset[data-set='" + set + "']");
		var selectedPosition = activeDataArray[1];
		var selectedTab = activeDataArray[2];

		setLocationActive(set, selectedPosition);
		$(".js-select-position.selected[data-set='" + set + "']").trigger('click');
		if (selectedTab != '') {
			$embroideryset.find('button[data-tab="' + selectedTab + '"]').addClass('active-btn');
			$embroideryset.find('.' + selectedTab).addClass('active');
		}
		localStorage.removeItem('activeEmbroideryData');
	}
}

module.exports = {
	    init: function () {
	    	$(window).on('load', function () {
	    		/* Window load function for both Edit cart and Login persist data scenario */
	    		$('.data-embroidery').each(function() {
	    			var set = $(this).parents('.embroideryset').data('set');
	    			localStorage.setItem('isLogoArtChecked' + set, false);
	    			/* Check for login scenario persist personalization - Start */
	    			var finalBuild = localStorage.getItem('finalBuild' + set);
	    			if (finalBuild && finalBuild.length > 2) {
	    				$(this).val(finalBuild).attr('value', finalBuild);
	    				localStorage.setItem('finalBuild' + set, '');
	    			}
	    			var finalBuild2 = localStorage.getItem('finalBuild2');
	    			if (set == 1 && $('.js-finalBuild-1-input').val().length <= 2 && finalBuild2 && finalBuild2.length > 2) {
	    				$('.js-finalBuild-1-input').val(finalBuild2).attr('value', finalBuild2);
	    				localStorage.setItem('finalBuild2', '');
		    		}
	    			/* Check for login scenario persist personalization - End */

	    			if ($(this).val().length > 2) {

		    			hideEmbroiderySet(set);

		    			setEmbroideryData(set);

		    			generateJSONData(set);

		    			displayEmbroiderySelection(set);
	    			}
	    		});
	    		/* To set position/tab selection after login */
	    		setActiveSelection();

	    		updateProductPrice();
	    	});
	    },

	    positionSelector: function() {
	    	/* Event for selecting the Embroidery position for  Old  PDP */
	        $('.js-position-change').on("change", function () {
	            var selectedPosition = $(this).val();
	            var set = $(this).data('set');

	            setLocationActive(set, selectedPosition);

	            if (!newPersonalization) {
	            	generateJSONData(set);
	            }

	            validatePersonalization(set);
	        });

	        /* Event for selecting the Embroidery position for  New  PDP */
	        $('.js-select-position').on("click", function () {
	            var selectedPosition = $(this).data('position');
	            var set = $(this).data('set');
	            var $embroideryset = $(this).closest('.embroideryset');

				if(newPersonalization && $(this).hasClass('disabled') && $('.embroidery-set').hasClass('completed')) {
					$embroideryset.hide();
					$('.embroidery-set.completed').find('.js-edit-position').trigger('click');
					return;
				}	


	            $(".js-position-change[data-set='" + set + "'] option[data-position='" + selectedPosition + "']").prop('selected', true).change();
	            $embroideryset.removeClass('select-location').addClass('editembroset');
	            $(".embroidery_disclaimer").show();

	            if (newPersonalization) {
	                $embroideryset.find('.positionHeaderContainer .logo-tab-container').show();
	                $embroideryset.find('.positionHeaderContainer .js-remove-position').show();
	                $embroideryset.find('.embroidery-line-options, .js-embroidery-inputs').addClass('active');
	                $('.select-location-label').addClass('d-none');

	            } else {
	            	$embroideryset.find('.js-remove-position').show();
	            }
	        });

	        /* Event for adding another location */
	        $(".js-add-location").on('click', function () {
	            $('.embroidery__addset__option').hide();
	            var setNew = $('.embroidery-set:not(.completed):first').data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + setNew + "']");
	            $('.select-location-label').removeClass('d-none');
	            $embroideryset.show();
	        });
	    },

	    logoTabSelector: function() {
	    	/* Event for selecting the logo tabs */
	        $(document).on('click touchstart', '.js-embroidery-tab' , function(e) {
		        e.preventDefault();

		        var set = $(this).closest('.embroideryset').attr('data-set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            $('.new-pdp-layout .embroideryGraphic.set-' + set).addClass('active');

	            resetLogoSelection(set);

	            var activeTabClass = '.embroidery__logo-search';
		        if (newPersonalization) {
		            /*To activate tab header*/
		            $(this).addClass('active-btn');

		            /*To activate tab content*/
		            activeTabClass = '.' + $(this).data('tab');
		            $embroideryset.find(activeTabClass).addClass('active');
		        } else {
		        	$embroideryset.find('.embroidery__logo-search').addClass('active');
		        	if (!$embroideryset.find('.js-select-graphic.selected').length) {
		                $embroideryset.find('.js-select-graphic').first().focus();
		            }
		        }

	            validatePersonalization(set);

	            $('html, body').animate({
	                scrollTop: $($embroideryset).find(activeTabClass).offset().top -  $('#header-container').height()
	            }, 'slow');
	        });
	    },

	    logoSelector: function() {
	    	/* Event for selecting the stock or your logos */
	    	$(document).on('click', ".js-select-graphic, .js-select-ALgraphic", function () {
	    		var selectedPrice = $(this).data('price');
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            var altText = $(this).find('img').attr('alt');

	            /*Reset other logos and activate current logo*/
	            $embroideryset.find(".js-select-graphic").removeClass('selected');
	            $embroideryset.find('.js-custom-logo').val('');
	            $(this).attr('aria-label', 'Selected Emblem Name: '+ altText + ' Emblem Price: $'+ selectedPrice);
	            if (newPersonalization) {
	            	$embroideryset.find(".js-select-ALgraphic").removeClass('selected');
	            }
	            $(this).addClass('selected');
	            $embroideryset.addClass('customized');

	            /*Prepare image preview section*/
	            var name = $(this).data('name');
	            var imgName = $(this).find('img').attr('alt');
	            var selectedImage = $(this).data('image');
	            var price = $(this).data('price');
				var $emblemBox = $embroideryset.find(".emblemBox");
	            if (newPersonalization) {
	            	$emblemBox.html("<img src='" + selectedImage + "' data-price='" + price + "' alt='" + name + "' title='" + imgName + "'/>");
	                $embroideryset.find('.logo-preview-sec').addClass('active');
	            } else {
	            	$emblemBox.html("<img src='" + selectedImage + "' data-price='" + price + "' alt='" + name + "' title='" + imgName + "'/>");
	            }
				if ($emblemBox.parent().find('.removeEmblem').length == 0) {
					$emblemBox.parent().append("<button type='button' class='removeEmblem btn-underline'>Remove Emblem</button>");
				}
	            styleLineTextBox(set);
	            if (!newPersonalization) {
		            generateJSONData(set);

		        	updateProductPrice();
	            }
	            validatePersonalization(set);
	    	});

	    	/* OLD PDP add logo link selector event */
	    	$(".js-add-graphic").on('click', function (e) {
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            var posSelection = $embroideryset.find('select.js-position-change').val();
	            if (posSelection === 'none') {
	                $embroideryset.addClass('select-location');
	                $embroideryset.find('.js-remove-position').hide();
	            } else {
	                $embroideryset.addClass('editembroset');
	                $('.embroideryset[data-set="' + set + '"] .positionHeaderContainer .logo-tab-container').show();
	                $('.embroideryset[data-set="' + set + '"] .positionHeaderContainer .js-remove-position').show();
	            }
	            $embroideryset.find('.position-block').first().focus();
	        });
	    },

	    logoRemoveSelector: function () {
	    	/* Event to remove logo on click of remove in logo preview section */
		    $(document).on("click", ".removeEmblem", function (e) {
	            var set = $(this).prev('.emblemBox').data("set");
	            var $embroideryset = $(this).closest('.embroideryset');

	            var $customLogoContainer = $('.js-customLogoContainer');
	            $customLogoContainer.find('.js-custom-logo').val('');
	            $customLogoContainer.find('.js-customLogoResponse[data-custom-logo-set="'+set+'"]').removeClass('active').removeAttr('data-custom-logo-price').text('');

	            $(".js-select-graphic[data-set='" + set + "']").removeClass('selected');
	            $(".js-select-ALgraphic[data-set='" + set + "']").removeClass('selected');

	            if (newPersonalization) {
	                $(".emblemBox[data-set='" + set + "']").html("<div class='emblemBox__text'>Your Logo Here</div>");
	                $embroideryset.find('.logo-preview-sec').removeClass('active');
	            } else {
	                $(".emblemBox[data-set='" + set + "']").html('<button type="button" class="emblemBox__text js-add-emblem js-embroidery-tab"><i class="fas fa-plus" aria-hidden="true"></i> Add Emblem</button>');
	                $embroideryset.find('.embroidery__logo-search').removeClass('active');
	                $customLogoContainer.removeClass('active');
	            }
	            $embroideryset.find('.emblemBox').next().remove();
				$(this).remove();
	            if (!newPersonalization) {
		            generateJSONData(set);

		        	updateProductPrice();
	            }
	            validatePersonalization(set);
	        });
	    },

	    customLogoSelector: function () {
	    	/* To make custom logo text uppercase while typing */
	    	$('.custom-logo').on('input', function(){
	            $(this).val($(this).val().toUpperCase());
	        });

	    	/* NEW PDP - To switch user to New logo section from custom logo */
	    	$('.custom-logo-form .click-link').on('click', function(){
	            $(this).closest('.embroideryset').find('.get-new-logo').trigger('click');
	        });

	    	/* NEW PDP - To switch user to custom logo section from New logo */
	    	$('.logo-art-checkbox-link-section .click-link').on('click', function(){
	            $(this).closest('.embroideryset').find('.js-your-logo').trigger('click');
	        });

	    	/* OLD PDP - To show stock logo container on click of search */
	    	$(".js-show-search-btn").on('click', function (e) {
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            $embroideryset.find('.embroidery__logo-search').toggleClass('showsearch');
	            $embroideryset.find('.js-logo-search').val("").keyup().focus();
	        });

	    	/* OLD PDP - To show custom logo container on click of custom logo button */
	        $(".js-pick-custom-logo-btn").on('click', function (e) {
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            $embroideryset.find('.embroidery__logo-search').removeClass('active');
	            $embroideryset.addClass('showcustomlogo');
	            $embroideryset.find('.js-customLogoContainer').addClass('active');
	            $embroideryset.find('.js-custom-logo').focus();
	        });

	        /* NEW PDP - To cancel saved logo selection - Hidden */
	        $('.js-cancel-your-logo').on('click', function (e) {
	            e.preventDefault();
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            $('.logo-tab-container[data-set="'+ set +'"] .js-your-logo').attr('disabled', false);
	            $('.embroideryGraphic.set-' + set + ' .add-logo-container').removeClass('active');
	            $('.new-pdp-layout .embroideryGraphic.set-' + set).removeClass('active');
	            $($embroideryset).find('.embroideryGraphic').removeClass('logos-preview-active');
	        });

	        /* NEW PDP - To cancel stock logo selection - Hidden */
	        $('.js-cancel-stock-logo').on('click', function (e) {
	            e.preventDefault();
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            $embroideryset.find('.embroidery__logo-search').removeClass('active');
	            $('.logo-CTAbutton_container[data-set="'+ set +'"]  .stock-logo').attr('disabled', false);
	            $('.new-pdp-layout .embroideryGraphic.set-' + set).removeClass('active');
	        });

	        /* NEW PDP - To cancel custom logo selection - Hidden */
	        $(".js-cancel-custom-logo").on('click', function () {
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            $embroideryset.removeClass('showcustomlogo');
	            $embroideryset.find('.embroidery__logo-search').addClass('active');
	            $embroideryset.find('.js-custom-logo').val("");
	            $embroideryset.find('.js-customLogoContainer').removeClass('active');
	        });

	    	/* Event for adding/validating a new custom logo code */
	        $(".custom-logo-button").on('click', function () {
	            var searchURL = $(this).data('search');
	            var set = $(this).data('set');
	            var code = $('.custom-logo[data-set="' + set + '"]').val();
	            var $embroideryset = $(this).closest('.embroideryset');
	            $embroideryset.find('.js-customLogoResponse').removeClass('active').html('');
	            if (code === '') {
	                $embroideryset.find('.js-custom-logo').addClass('is-invalid');
	                var validationMsg = $($embroideryset).find(".js-customLogoContainer").find(".invalid-feedback").data('missing');
	                $embroideryset.find(".js-customLogoContainer").find(".invalid-feedback").text(validationMsg).show();
	            } else {
	                $embroideryset.find('.js-custom-logo').removeClass('is-invalid');
	                if (!$(this).closest('.custom-logo-form').find('.js-custom-logo').hasClass('custom-logo-code')) {
	                    $(this).closest('.custom-logo-form').find('.js-custom-logo').addClass('custom-logo-code');
	                }
	                $embroideryset.find(".js-customLogoContainer").find(".invalid-feedback").hide();
	            }
	            code = code.trim();

	            if (code.length < 1) {
	                return false;
	            }
	            if ($('.approved-logo-section.registered').length > 0) {
	                var customLogoInputCodeValue = $(this).closest('.custom-logo-form').find('.js-custom-logo').val().trim();
	                if ($('.ALGraphicsContainer button[data-name="' + code + '"]').length > 0) {
	                    alert('Oops, looks like that custom emblem code is already in your account.');
	                    $('.js-customLogoResponse').removeClass('active').text('');
	                    return false;
	                }
	            }
	            var emblemBuild = {};
	            $.ajax({
	                url: searchURL,
	                method: 'GET',
	                async: false,
	                data: {
	                    'logoCode': code
	                },
	                success: function (data) {
	                    /* if there is a logo, add it to the input and pic, and select option and create string */
	                    if (data.emblem.length > 0) {
	                        var selectedPrice = data.emblem[0];
	                        var name = data.emblem[2];
	                        var image = data.emblem[1];
	                        var code = data.emblem[3];

	                        /* Deselect existing graphic selection */
	                        $embroideryset.find('.js-select-graphic').removeClass('selected');
	                        var $emblemBox = $embroideryset.find(".emblemBox");
	                        if (newPersonalization) {
	                        	$embroideryset.find('.js-select-ALgraphic').removeClass('selected');
	                        	$emblemBox.html("<img src='" + image + "' class='logo-code-added' data-price='" + selectedPrice + "' alt='" + code + "' title='" + name + "'/>");
	                            $embroideryset.find('.logo-preview-sec').addClass('active');

	                            /* Adding custom logo to registered user account logo container */
	                            if ($('.approved-logo-section.registered').length > 0) {
	                            	$embroideryset.find('.ALGraphicsContainer .js-select-ALgraphic.ALGraphic').removeClass('selected');
	                                $('.ALGraphicsContainer').each(function(index){
	                                    var $button = $("<button>", {
	                                                                type: "button",
	                                                                class: "js-select-ALgraphic ALGraphic customcode mt-2",
	                                                                "data-image": data.emblem[1],
	                                                                "data-price": data.emblem[0],
	                                                                "data-name": data.emblem[3],
	                                                                "data-set": ++index,
	                                                                "data-sort": "custom"
	                                                                });
	                                    $("<img>", {src: data.emblem[1],alt: data.emblem[3]}).prependTo($button);
	                                    $("<span>", {class: "sr-only"}).insertAfter($($button).find('img'));
	                                    $('<p>').insertAfter($($button).find('span'));
	                                    $($button).find('p').addClass('mb-0 custom-logo-name').text(data.emblem[3]);
	                                    $('.ALgraphicsTitle').text($('.approved-logo-section.registered').attr('data-yourSavedLogos'));
	                                    $(this).prepend($button);
	                                });
	                                $embroideryset.find('.ALGraphicsContainer').find('button').first().addClass('selected');
	                            }
	                        } else {
	                        	$emblemBox.html("<img src='" + image + "' data-price='" + selectedPrice + "' alt='" + code + "' title='" + name + "'/>");
	                        }
	                        
	                        if ($emblemBox.parent().find('.removeEmblem').length == 0) {
	        					$emblemBox.parent().append("<button type='button' class='removeEmblem btn-underline'>Remove Emblem</button>");
	        				}

	                        $embroideryset.find('.js-customLogoResponse').addClass('active')
	                        											 .attr('data-custom-logo-set', set)
	                        											 .attr('data-custom-logo-price', selectedPrice)
	                        											 .text('Code Accepted. Your logo has been applied.');

	                        $embroideryset.find('.embroideryGraphic').addClass('logos-preview-active');
	                        $embroideryset.addClass('customized');
	                    } else {

							if (data.basicCustomLogo.length > 0) {
								return false
							}
							
	                        if (newPersonalization) {
	                        	$embroideryset.find('.emblemBox').html("<div class='emblemBox__text'>Your Logo Here</div>");
	                        	$embroideryset.find('.logo-preview-sec').removeClass('active');
	                        } else {
	                        	$embroideryset.find('.emblemBox').html('<button type="button" class="emblemBox__text js-add-emblem js-embroidery-tab"><i class="fas fa-plus" aria-hidden="true"></i> Add Emblem</button>');
	                        }
	                        $embroideryset.find('.emblemBox').next().remove();
	                        alert('Sorry, that custom emblem code is invalid.');
	                    }
	                    if (!newPersonalization) {
	                        generateJSONData(set);

	        	        	updateProductPrice();
                        }
	                    if ($('.approved-logo-section.registered button.js-select-ALgraphic').length > 0) {
	                        $('.ALgraphicsFooter').each(function() {
	                            $(this).text($('.approved-logo-section.registered').attr('data-logomsg'));
	                        });
	                    }

	                    if ($('.approved-logo-section.registered .ALgraphicsbox').hasClass('justify-content-center')) {
	                        $('.approved-logo-section.registered .ALgraphicsbox').removeClass('justify-content-center');
	                    }
	                    validatePersonalization(set);
	                },
	                error: function (e) {
	                    console.log("Internal Error: " + e);
	                }
	            });
	        });
	    },

	    logoFilterSelector: function() {
	        /* Event for filtering emblem logos based embroidery category names */
	        $(".js-sort-category").on('change', function () {
	            var selectedCategory = $(this).val();
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            $embroideryset.find(".basicGraphic").hide();
	            if (selectedCategory == "view-all") {
	            	$embroideryset.find(".basicGraphic").show();
	            } else {
	            	$embroideryset.find(".basicGraphic[data-sort='" + selectedCategory + "']").show();
	            }
	        });

	        $(".logo-search").on('keyup', function () {
	            var searchURL = $(this).data('search');
	            var set = $(this).data('set');
	            var code = $(this).val();
	            code = code.trim();

	            $.ajax({
	                url: searchURL,
	                method: 'GET',
	                data: {
	                    'search': code
	                },
	                success: function (data) {
	                    var results = '';
	                    if (data.emblems.length > 0) {
	                        //if there are returned logos, add to box.
	                        data.emblems.forEach(function (item, index) {
	                            results += '<button class="js-select-graphic basicGraphic" data-image="' + item[1] + '" data-set="' + set + '"data-sort="'+ item[3] +'" data-price="' + item[0] + '" data-name="' + item[4] + '">';
	                            results += '   <img src="' + item[1] + '" alt="' + item[2] + '" /><br>';
	                            results += '   $' + item[0] + '<br>';
	                            results += item[2];
	                            results += '</button>';
	                        });
	                    } else {
	                        results = data.emptyMsg;
	                    }
	                    $('.graphicsbox[data-set="' + set + '"]').html(results);
	                },
	                error: function () {
	                    console.log("Sorry! no results found");
	                }
	            });
	        });
	    },

	    logoArtSelector: function() {
	        $('input.js-logoArtCheckbox').on('change', function () {
	            var isChecked = $(this).hasClass('checked');
	            var set = $(this).closest('.embroideryset').data('set');
	            var isLineTextValue = false;
	            var isLogoAdded = false;

	            if ($(this).closest('.embroideryset').find('.emblemBox img').length > 0) {
	                isLogoAdded = true;
	            }

	            $('.js-embroidery-inputs-' + set + ' .js-addEmbroidery').each(function () {
	                if ($(this).val().trim() !== "") {
	                    isLineTextValue = true;
	                }
	            });
	            if (isChecked) {
	                $(this).prop('value', false).prop('checked', false).removeClass('checked');
	                if (!isLineTextValue && !isLogoAdded) {
	                    $(this).closest('.embroideryset').find('.js-done-btn').addClass('disabled');
	                }
	                $('.embroideryset-' + set).removeClass('customized');
	            } else {
	                $(this).prop('value', true).prop('checked', true).addClass('checked');
	                $(this).closest('.embroideryset').find('.js-done-btn').removeClass('disabled');
	                $('.embroideryset-' + set).addClass('customized');
	            }
	        });
	    },

	    lineSelector: function() {
	    	/* Line text type event */
	    	$('.js-addEmbroidery').on('input keyup change paste blur keydown', function (e) {
	            var lineText = $(this).val().trim();
	            var addToCartButton = $(this).closest('.product-second-col').find('button.add-to-cart, button.add-to-cart-global');
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");

	            /* check if user has tried clicking apply and it caused blur, trigger click on js-done-btn in that case */
	            if (e.relatedTarget && e.relatedTarget.classList.length && e.relatedTarget.classList.contains('js-done-btn')) {
	                $embroideryset.find('.js-done-btn').trigger('click');
	                return false;
	            }

	            if (lineText !== "") {
	            	/* Replace ios device smart quotes/smart dots/em dash in to respective symbols */
	            	var iosLineText = $(this).val()
	            						.replace(/[\u2018\u2019]/g, "'")
	            						.replace(/[\u2026]/g, "...")
	            						.replace(/[\u2014]/g, "--");
	            	$(this).val(iosLineText.replace(/[^a-z0-9 !',.-]/gi, ''));
	            }

	            /* modified to handle lines+saved logo issue (fast typed line and apply clicked w/o clicking outside) */
	            if (lineText.length && (e.type == 'input' || e.type == 'keyup' || e.type == 'paste' || e.type == 'keydown')) {
	                debouncedHandleLineTextSelection($(this), set);
	            }
	    	});

	    	/* Click event for displaying/adding new lines for new PDP*/
	    	$('.line-link').on('click', function () {
	            $(this).addClass('d-none');
	            $(this).prev('input').addClass('w-100');
	            $(this).closest('.line-item').next('.line-item').removeClass('hide').addClass('active');
	            $(this).parents('.form-group').next().find('input').focus();
	        });

	    	/* KeyPress event for line text field focus enter action */
	    	$(document).on("keypress", ".line-link:focus", function(e) {
				if (e.key == "Enter" || e.keyCode == 13) {
					$(this).trigger('click');
				}
			});

	    	/* KeyPress event for mobile device screen keyboard max length validation */
	    	$('input.js-addEmbroidery').on('keyup', function () {
	            var maxLength = $(this).attr('maxlength'),
	                val = $(this).val(),
	                trimmed;
	            if (maxLength && val) {
	            	trimmed = val.substr(0, maxLength);
	            	$(this).val(trimmed);
	            }
	    	});

	    	/* Click event for displaying/adding new lines for old PDP */
	        $(".js-add-line").on('click', function (e) {
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	            var $visibleTextInputs = $embroideryset.find('.js-embroidery-inputs .form-group:visible');
	            var $hiddenInputContainer = $embroideryset.find('.js-embroidery-inputs .form-group:hidden').eq(0).closest('.form-group');
	            $hiddenInputContainer.show();
	            $hiddenInputContainer.find('.embroidery__input').focus();

	            var totalInputLines = $('.embroidery__inputs input').length;
	            if ($visibleTextInputs.length == 2 || totalInputLines == 2) {
	                $embroideryset.find(".js-add-line, .js-add-line__divider").hide();
	            }
	        });
	    },

	    styleSelector: function () {
	    	/* Event for selecting/changing the thread color */
	        $('.js-style-change').on("change", function (e) {
	            var set = $(this).data('set');

	            $(this).closest('.embroidery-options__container').removeClass('invalid');

	            styleLineTextBox(set);

	            /* To Generate JSON data used for OLD PDP addtocart/edit/signin scenarios */ 
	            if (!newPersonalization) {
	            	generateJSONData(set);
	            }

	            validatePersonalization(set);
	        });
	    },

	    applyPersonalization: function () {
	    	/* Event for applying  the selected embroidery position details like emblems and custom logo and embroider lines */
	        $(".js-done-btn").on('click', function () {
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");

	            var isValid = validatePersonalization(set, true);
	            if (!isValid) {
	            	$('html, body').animate({
		                scrollTop: $('.embroidery-options__container.invalid').offset().top -  $('#header-container').height()
		            }, 'slow');
	            	return false;
	            }
	            $(".embroidery-set[data-set='" + set + "']").addClass('completed');

	            /* To hide the respective completed embroidery set */
	            hideEmbroiderySet(set);

	            /* To Generate JSON data used for addtocart/edit/signin scenarios */ 
	            generateJSONData(set);

	            /* To display customer entered data in completed section for preview*/
	            displayEmbroiderySelection(set);

	        	/* To calculate product price based on options set */
	        	updateProductPrice();

	            $('html, body').animate({
	                scrollTop: $('.section-embroidery').offset().top -  $('#header-container').height()
	            }, 'slow');
	        });
	    },

	    cancelPersonalization: function () {
	    	/* Event to cancel the personalization edit data */
	    	$(".js-cancel-btn").on('click', function (e) {
	    		var set = $(this).data('set');
	    		var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	    		$embroideryset.removeClass('customized');
	    		$embroideryset.find('.embroidery-options__container').removeClass('invalid');
	    		if (newPersonalization) {
	    			var isLogoArtChecked = localStorage.getItem('isLogoArtChecked' + set);
		    		/* Only reset entered values and selected logo */
		    		resetEmbroideryData(set, true, false);
		    		localStorage.setItem('isLogoArtChecked' + set, isLogoArtChecked);
	    			hideEmbroiderySet(set);
	    			if (!$(".embroideryset").is(':visible') && !$('.embroidery-sets .completed').length) {
	    				$('.embroideryset-1').show();
	    			}
					if (newPersonalization && ($($embroideryset).find('button.js-select-position.disabled').text().toLowerCase().includes('edit') && !$($embroideryset).find('button.js-select-position.selected').text().toLowerCase().includes('add'))) {
						$($embroideryset).find('button.js-select-position.selected').text('Add ' + $($embroideryset).find('button.js-select-position.selected').text());
					}
	    		} else {
	    			$($embroideryset).find('.js-remove-position').trigger('click');
	    		}

	    		if ($('.embroidery-set.completed').length < 1) {
	    			$('.embroidery-sets').hide();
	    		}

	    		$('html, body').animate({
	                scrollTop: $('.section-embroidery').offset().top -  $('#header-container').height()
	            }, 'slow');
	    	});
	    },

	    editPersonalization: function () {
	    	/* Event to edit completed personalization set */
	    	$(".js-edit-position").on('click', function (e) {
	    		var set = $(this).data('set');
	    		var isLogoArtChecked = localStorage.getItem('isLogoArtChecked' + set);
	    		/* Only reset entered values and selected logo */
	    		resetEmbroideryData(set, true, false);
	    		localStorage.setItem('isLogoArtChecked' + set, isLogoArtChecked);

	    		setEmbroideryData(set);

	    		showEmbroiderySet(set);

				if (newPersonalization && !$("button.js-select-position[data-set!='" + set + "']").hasClass('selected')) {
					$(".embroideryset[data-set!='" + set + "']").find('.js-cancel-btn').trigger('click');
				}
				if (newPersonalization && $(".embroideryset[data-set!='" + set + "']").hasClass('editembroset') && $("button.js-select-position[data-set!='" + set + "']").hasClass('selected')) {
					if ($("button.js-select-position.selected[data-set!='" + set + "']").text().includes('Add')) {
						$("button.js-select-position.selected[data-set!='" + set + "']").text($("button.js-select-position.selected[data-set!='" + set + "']").text().replace('Add', ''))
					}
				}
	    	});
	    },

	    removePositionSelector: function () {
	    	/* Event to remove completed personalization set */
	    	$(".js-remove-position").on('click', function (e) {
	            var set = $(this).data('set');
	            var $embroideryset = $(".embroideryset[data-set='" + set + "']");

				if (localStorage.getItem('isLogoArtChecked' + set) == 'true') {
					localStorage.setItem('isLogoArtChecked' + set, 'false');
				}

	            /* If first set deleted while 2nd set completed/edited, shift the 2nd set data into the first set -- otherwise saved options will mismatch */
	            if (set == 1 && (($('.js-finalBuild-2-input').length > 0 && $('.js-finalBuild-2-input').val().length > 2) || $('.embroideryset-2').hasClass('customized'))) {
	            	shiftEmbroiderySet();
	            	styleLineTextBox('1');
					if (newPersonalization) {
						$("button.js-select-position.selected[data-set='1']").text($("button.js-select-position.selected[data-set='1']").text().replace('Edit', ''));
					}
	            } else {
	            	/* Remove both set If 2nd set opened but not entered anything and customer removed 1st set*/
	            	if ($(".embroideryset[data-set='2']").length > 0) {
	            		removeEmbroiderySet('2');
						if (newPersonalization && !$("button.js-select-position[data-set='2']:not(.disabled)").text().toLowerCase().includes('add')) {
							$("button.js-select-position[data-set='2']:not(.disabled)").text('Add' + $("button.js-select-position[data-set='2']:not(.disabled)").text())
						}						
	            	}
	            	removeEmbroiderySet(set);
	            }
	            if ($('.embroidery-set.completed').length < 1) {
	            	$('.embroideryset-1').show();
	                $(".embroidery_disclaimer").hide();
	                $('.embroidery__addset__option').hide();
	            }
	            updateProductPrice();
				if (newPersonalization && $('.embroidery-set.completed').length < 1 && !$(".embroideryset").hasClass('customized')) {		
					$($embroideryset).find('button.js-select-position').map(function() {
						if ($(this).text().includes('Add') || $(this).text().includes('Edit')) {
							$(this).text($(this).attr('data-position'));
						}							
					});
				}
	            validatePersonalization(set);
	        });
	    },

	    accountSelector: function () {
	    	/* Event to store applied personalization on click of signin link */
	    	$('body').on('click', '.signin-modal', function () {
	    		$('.data-embroidery').each(function () {
	    			var set = $(this).parents('.embroideryset').data('set');
	    			var finalBuild = $(this).val();
	    			localStorage.setItem('finalBuild' + set, finalBuild);
	    		});

	    		/* New PDP position and tab selection persist after signin */
	    		if (newPersonalization && $('.js-finalBuild-1-input').length > 0) {
	    			var set = $('.js-finalBuild-1-input').val().length > 2 ? 2 : 1;
	    			var $embroideryset = $(".embroideryset[data-set='" + set + "']");
	    			if ($embroideryset.find('.js-embroidery-tab.active-btn').length > 0) {
	    				var selectedPosition = $embroideryset.find('.select-position.selected').data('position');
	    				var selectedTab = $embroideryset.find('.js-embroidery-tab.active-btn').data('tab');

	    				/* Active embroidery data format set|position|logoTab */
	    				var activeData = set + '|' + selectedPosition + '|' + selectedTab;
	    				localStorage.setItem('activeEmbroideryData', activeData);
	    			}
	    		}
	    	});
	    }
};